module.exports = __webpack_public_path__ + "img/kf.775c2981.jpg";